import { EmbeddedVideo } from './EmbeddedVideo';

export default EmbeddedVideo;
